<template>
  <div
    class="spacer"
    :class="classes"
  />
</template>

<script>
export default {
  name: 'KfSpacer',
  props: {
    size: {
      type: String,
      default: 'md',
    },
  },
  computed: {
    classes() {
      return {
        [`has-size-${this.size}`]: this.size,
      }
    },
  },
};
</script>

<style lang="postcss">
.spacer {
  @apply pb-12;

  @screen md {
    @apply pb-20;
  }

  &.has-size-xs {
    @apply pb-4;

    @screen md {
      @apply pb-6;
    }
  }

  &.has-size-sm {
    @apply pb-8;

    @screen md {
      @apply pb-12;
    }
  }

  &.has-size-lg {
    @apply pb-16;

    @screen md {
      @apply pb-24;
    }
  }

  &.has-size-xl {
    @apply pb-20;

    @screen md {
      @apply pb-28;
    }
  }
}
</style>
